<template>
    <div class="w-100">
        <!-- Header Section -->
        <div class="filter-header">
            <div class="fs-14 font-weight-bold ml-4">Filters <span style="color:#ffba00 !important;">({{totalFilters}})</span></div>
            <div class="pointer">
                <el-tooltip class="item" effect="dark" content="Close" placement="top">
                    <span @click="closeFilters()">
                        <img class="filter-Images" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/CloseBgBlue.svg" alt="close">
                    </span>
                </el-tooltip>
            </div>
        </div>
        <!-- Filter Body Section -->
        <div class="row w-100 m-0">
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class=" mt-4">
                    <span class="fs-14 text-secondary font-weight-bold">
                        Auction Name
                    </span>
                    <multiselect :loading="auction_loading"
                        label="auction_name" id="ajaxpr"
                        track-by="id" @search-change="searchAuction"
                        :limit="1" :limit-text="limitAuctionTo"
                        placeholder="Select Auction Name" class="digi-multiselect approval-manager filter-multiple mt-2"
                        :options="auction_name_options" v-model="auction_name"
                        :multiple="true" :searchable="true" :internal-search="true"
                        :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true"
                        :hide-selected="false" @remove="removeAuctuionTo">
                        <template slot="tag" slot-scope="{ option }">
                            <span class="custom__tag">
                            <span class="filterSelectedName">{{ option.auction_name }}</span>
                                <span class="custom__remove pointer" @click="removeAuctuionTo(option)">
                                <i class="icon icon-close fs-16 text-white"></i>
                                </span>
                            </span>
                        </template>
                        <template slot="afterList">
                            <div v-observe-visibility="reachedEndOfEmployees" />
                        </template>
                        <template slot="noResult">
                            <div class="text-secondary text-center fw-600">No Results Found</div>
                        </template>
                    </multiselect>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class=" mt-4">
                    <span class="fs-14 text-secondary font-weight-bold">
                        Bidder Name
                    </span>
                    <multiselect :loading="bidder_loading" @search-change="searchBidder"
                        :limit="1" :limit-text="limitAuctionTo"
                        placeholder="Select Bidder Name" class="digi-multiselect approval-manager filter-multiple mt-2"
                        :options="auction_bidder_options" v-model="bidder_name"
                        :multiple="true" :searchable="true" :internal-search="true"
                        :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true"
                        :hide-selected="false" @remove="removeBidderTo">
                        <template slot="tag" slot-scope="{ option }">
                            <span class="custom__tag">
                            <span class="filterSelectedName">{{ option }}</span>
                                <span class="custom__remove pointer" @click="removeBidderTo(option)">
                                <i class="icon icon-close fs-16 text-white"></i>
                                </span>
                            </span>
                        </template>
                        <template slot="afterList">
                            <div v-observe-visibility="reachedEndOfBidder" />
                        </template>
                        <template slot="noResult">
                            <div class="text-secondary text-center fw-600">No Results Found</div>
                        </template>
                    </multiselect>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class=" mt-4">
                    <span class="fs-14 text-secondary font-weight-bold">
                        Company Name
                    </span>
                    <multiselect :loading="company_loading" @search-change="searchCompany"
                        :limit="1" :limit-text="limitAuctionTo"
                        placeholder="Select Company Name" class="digi-multiselect approval-manager filter-multiple mt-2"
                        :options="auction_company_options" v-model="company_name"
                        :multiple="true" :searchable="true" :internal-search="true"
                        :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true"
                        :hide-selected="false" @remove="removeCompanyTo">
                        <template slot="tag" slot-scope="{ option }">
                            <span class="custom__tag">
                            <span class="filterSelectedName">{{ option }}</span>
                                <span class="custom__remove pointer" @click="removeCompanyTo(option)">
                                <i class="icon icon-close fs-16 text-white"></i>
                                </span>
                            </span>
                        </template>
                        <template slot="afterList">
                            <div v-observe-visibility="reachedEndOfCompany" />
                        </template>
                        <template slot="noResult">
                            <div class="text-secondary text-center fw-600">No Results Found</div>
                        </template>
                    </multiselect>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class=" mt-4">
                    <span class="fs-14 text-secondary font-weight-bold">
                        Appeal Date
                    </span>
                    <div class="mt-2 d-flex align-items-center">
                        <div v-if="appeal_date.length" style="border-bottom: 1px solid #a9aaad;width: 100%;">
                            <div class="d-flex justify-content-between align-items-center"
                                style="background: #00448b; border-radius: 20px; padding-left: 10px;padding-top: 4px;padding-bottom: 4px; padding-right: 10px; margin-top: 0px; margin-bottom: 8px; width: 120px;">
                                <input type="text"
                                    :value="appeal_date"
                                    style="color: #fff; background: #00448b;font-weight: 500;width: 8rem;" disabled />
                                <span
                                    @click="appealDateClose()"
                                    style="color: #fff; cursor: pointer;font-weight: 600;">&#10005;</span>
                            </div>
                        </div>
                        <date-picker v-else
                            v-model="appeal_date"
                            placeholder="Select Closing Date"
                            name="appeal_date"
                            class="meetinfdatetimes mx-left calendar-edit-per mr-1"
                            format="YYYY/MM/DD"
                            value-type="format"
                            type="date"
                            lang="en"
                            :clearable="false"
                            :editable="false"
                            confirm
                            confirm-text="APPLY"
                            @change="changeCount('start_date')"
                        ></date-picker>
                    </div>
                </div>
            </div>
        </div>
        <!-- Buttons Section -->
        <div class="d-flex flex-wrap mb-2 mt-2 mr-3" style="float: right !important;">
            <button class="btn mt-2 ml-6 new-reset-button" @click="clearAllSelected()">Reset</button>
            <button class="btn mt-2 ml-6 new-apply-button" @click="applyFilter">Apply</button>
        </div>
    </div>
</template>
<script>
import { EventBus } from '../eventBus/nav-bar-event';
import { debounce } from 'lodash'
import Convert from "../mixins/convert.js"
import Auction from "../mixins/auction.js"
export default {
    mixins: [Auction, Convert],
    props: ["showfilterData"],
    data(){
        return{
            auction_name: [],
            auction_name_options: [],
            bidder_name: [],
            bidder_name_options: [],
            company_name: [],
            bidder_name_options: [],
            appeal_date: "",
            auction_opening_date: "",
            auction_cloing_date:"",
            auction_loading: false,
            template: [],
            date_count: 0,
            start_date_reached: false,
            end_date_reached: false,
            auction_visible:false,
            search_key: "",
            auction_count: 0,
            auction_scrollable: false,
            value_targeted: 0,
            company_targeted: 0,
            bidder_targeted:0,
            bidder_scrollable: false,
            bidder_loading: false,
            bidder_count: 0,
            bidder_visible:false,
            auction_bidder_options:[],
            company_scrollable: false,
            company_loading: false,
            company_count: 0,
            company_visible:false,
            auction_company_options:[],
        }
    },
    methods:{
        appealDateClose(){
            this.appeal_date = ""
        },
        //API call to get first 10 auction names
        async searchAuctionDebouncer(search_key) {
            this.search_key = search_key
            this.auction_loading = true
            try {
                let params = {
                    limit: 10,
                    skip: 0,
                    search_key: this.search_key,
                    sort_key: "",
                    sort_value: -1,
                    filter: {}
                };
                let response = await this.getAuctionsList(params)
                this.auction_name_options = response.data.auction_data;
                this.auction_count = response.data.auction_data.length;
                this.auction_loading = false
            }
            catch(error) {
            }
        },
        //Lazy loading for auction names
        async reachedEndOfEmployees(reached) {
            this.auction_visible = reached
            if (reached) {
                if (this.auction_scrollable == false) {
                    this.auction_loading = true
                    let response = await this.getAuctionsList({
                        limit: 10,
                        skip: this.auction_count,
                        search_key: this.search_key,
                        sort_key: "",
                        sort_value: -1,
                        filter: {}
                    })
                    this.temp_products = response.data.auction_data.length;
                    if (response.data.skip == this.auction_count) {
                        if (this.temp_products > 0) {
                            let tempFiles = response.data.auction_data;
                            tempFiles.forEach(el => {
                                this.auction_name_options.push(el);
                            });
                            this.auction_name_options = this.auction_name_options.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.auction_name_options.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });
                            });
                            this.auction_count += response.data.auction_data.length;
                            this.auction_loading = false
                        } else {
                            this.auction_scrollable = true
                            this.auction_loading = false
                        }
                    }
                    this.auction_loading = false
                }
            }
        },
        //API call to get first 10 bidders data
        async searchbidderDebouncer(search_key) {
            this.search_key = search_key
            this.bidder_loading = true
            try {
                let params = {
                    limit: 10,
                    skip: 0,
                    search_key: this.search_key,
                    sort_key: "bidder_name",
                    sort_value: -1,
                    filter: {
                        auction_id: [this.$route.params.id]
                    }
                };
                let response = await this.getBiddersData(params)
                this.auction_bidder_options = response.response;
                this.bidder_count = response.response.length;
                this.bidder_loading = false
            }
            catch(error) {
            }
        },
        //Lazy loading for bidders list API call
        async reachedEndOfBidder(reached) {
            this.bidder_visible = reached
            if (reached) {
                if (this.bidder_scrollable == false) {
                    this.bidder_loading = true
                    let response = await this.getBiddersData({
                        limit: 10,
                        skip: this.bidder_count,
                        search_key: this.search_key,
                        sort_key: "bidder_name",
                        sort_value: -1,
                        filter: {}
                    })
                    this.temp_products = response.response.length;
                    if (response.skip == this.bidder_count) {
                        if (this.temp_products > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.auction_bidder_options.push(el.bidder_name);
                            });
                            this.auction_bidder_options = this.auction_bidder_options.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.auction_bidder_options.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });
                            });
                            this.bidder_count += response.response.length;
                            this.bidder_loading = false
                        } else {
                            this.bidder_scrollable = true
                            this.bidder_loading = false
                        }
                    }
                    this.bidder_loading = false
                }
            }
        },
        //API call to get first 10 company names
        async searchCompanyDebouncer(search_key) {
            this.search_key = search_key
            this.company_loading = true
            try {
                let params = {
                    limit: 10,
                    skip: 0,
                    search_key: this.search_key,
                    sort_key: "bidder_name",
                    sort_value: -1,
                    filter: {}
                };
                let response = await this.getBiddersData(params)
                this.auction_company_options = response.response;
                this.company_count = response.response.length;
                this.company_loading = false
            }
            catch(error) {
            }
        },
        //Lazy loading for company name API call
        async reachedEndOfCompany(reached) {
            this.company_visible = reached
            if (reached) {
                if (this.company_scrollable == false) {
                    this.company_loading = true
                    let response = await this.getBiddersData({
                        limit: 10,
                        skip: this.company_count,
                        search_key: this.search_key,
                        sort_key: "bidder_name",
                        sort_value: -1,
                        filter: {}
                    })
                    this.temp_products = response.total_count;
                    if (response.skip == this.company_count) {
                        if (this.temp_products > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.auction_company_options.push(el.company_name);
                            });
                            this.auction_company_options = this.auction_company_options.filter(Boolean);
                            this.auction_company_options = this.auction_company_options.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.auction_company_options.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });
                            });
                            this.company_count += response.response.length;
                            this.company_loading = false
                        } else {
                            this.company_scrollable = true
                            this.company_loading = false
                        }
                    }
                    this.company_loading = false
                }
            }
        },
        resetData(type){
            this.selected_field = type
            this.auction_name_options = [];
            this.auction_count = 0;
        },
        //To increase total filter count when start and end date selected
        changeCount(obj){
            if(obj == 'start_date'){
                if(!this.start_date_reached){
                    this.date_count += 1;
                }
                this.start_date_reached = true
            } else if(obj == 'end_date'){
                if(!this.end_date_reached){
                    this.date_count += 1;
                }
                this.end_date_reached = true
            }
        },
        //Deletes selected auction
        removeAuctuionTo(option){
            this.auction_name.forEach((el,index)=>{
                if(el._id == option._id){
                    this.auction_name.splice(index,1)
                }
            })
        },
        //Deletes selected bidder
        removeBidderTo(option){
            this.bidder_name.forEach((el,index)=>{
                if(el._id == option._id){
                    this.bidder_name.splice(index,1)
                }
            })
        },
        //Deletes selected company
        removeCompanyTo(option){
            this.company_name.forEach((el,index)=>{
                if(el._id == option._id){
                    this.company_name.splice(index,1)
                }
            })
        },
        limitAuctionTo(count){
            return `+ ${count} more`
        },
        closeFilters(){
            this.hide_filters = false
            this.$emit('hideFilters')
        },
        //To clear all selected filter data
        clearAllSelected(){
            this.auction_name = [],
            this.bidder_name = [],
            this.company_name = [],
            this.appeal_date = ""
            let newData = {
                filterData: {
                    auction_id: [],
                    bidder_name: [],
                    company_name: [],
                    appeal_date: ""

                },
                showfilterData: {
                    auction_id: [],
                    bidder_name: [],
                    company_name: [],
                    appeal_date: ""
                }
            }
            this.date_count = 0
            this.start_date_reached = false
            this.end_date_reached = false
        },
         convertFilter(str) {
            var date = new Date(str),
                mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                day = ("0" + date.getDate()).slice(-2);
            return [day, mnth, date.getFullYear()].join("-");
        },
        //Emits to list view with selected filter data to call API  
        applyFilter(){
            let params = {
                auction_id:this.auction_name == "" ? this.auction_name : [...new Set(this.auction_name.map(x => x.id))],
                bidder_name:this.bidder_name,
                company_name:this.company_name,
                appeal_date:this.appeal_date,
            }
            let params1 = {
                auction_id:this.auction_name == "" ? this.auction_name : [...new Set(this.auction_name.map(x => x.id))],
                bidder_name:this.bidder_name,
                company_name:this.company_name,
                appeal_date:this.appeal_date,
            }
            let newData = {
                value: params,
                value1: params1
            }
            this.$emit('UpdateByFilter', newData)
            this.closeFilters();
        },
        
    },
    async mounted(){
        // this.auction_name = this.showfilterData.auction_id
        this.bidder_name = this.showfilterData.bidder_name
        this.company_name = this.showfilterData.company_name
        this.appeal_date = this.showfilterData.appeal_date
    },
    created(){
        this.searchAuction = debounce(this.searchAuctionDebouncer, 500)
        this.searchBidder = debounce(this.searchbidderDebouncer, 500)
        this.searchCompany = debounce(this.searchCompanyDebouncer, 500)
    },
    computed: {
        totalFilters(){
            return this.date_count + this.auction_name.length + this.bidder_name.length + this.company_name.length;
        }
    },
}
</script>
<style scoped>
    .place-holder{
        margin-left: 10px;
    }
    .pl-ho input.mx-input::-webkit-input-placeholder {
        color: #7b7f83 !important;
        line-height: 1.42857143 !important;
        font-size: 13px !important;
        font-weight: normal !important;
        padding-left: 10px !important
    }
    .pl-ho input.mx-input::placeholder {
        color: #7b7f83 !important;
        line-height: 1.42857143 !important;
        font-size: 13px !important;
        font-weight: normal !important;
        padding-left: 10px !important
    }
    .pl-ho input.mx-input::-moz-placeholder {
        color: #7b7f83 !important;
        line-height: 1.42857143 !important;
        font-size: 13px !important;
        font-weight: normal !important;
        padding-left: 10px !important
    }
    .pl-ho input.mx-input:-moz-placeholder {
        color: #7b7f83 !important;
        line-height: 1.42857143 !important;
        font-size: 13px !important;
        font-weight: normal !important;
        padding-left: 10px !important
    }
    .pl-ho input.mx-input:-ms-input-placeholder {
        color: #7b7f83 !important;
        line-height: 1.42857143 !important;
        font-size: 13px !important;
        font-weight: normal !important;
        padding-left: 10px !important
    }
</style>


// WEBPACK FOOTER //
// src/components/Auction/BidderFilterData.vue